export default __webpack_public_path__ + "static/media/Springboot.32cbc14e.webp";